import { makeStyles } from '@material-ui/core/styles';
import { borderRadius } from '../../../../styles/themes/vad/borderRadius';
import { pxToRem } from '../../../../styles/themes/vad/constants';
import { fontSize } from '../../../../styles/themes/vad/font';

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.mixins.marginLeft(pxToRem(24)),
    ...theme.shape.componentSpacing,
    marginTop: theme.spacing(5),
    position: 'relative',
    [theme.breakpoints.up('lg')]: {
      ...theme.mixins.marginLR(pxToRem(92), pxToRem(92)),
      marginTop: theme.spacing(11),
    },
    '& img': {
      display: 'block',
      cursor: 'pointer',
      objectFit: 'cover',
    },
  },
  gridList: {
    flexWrap: 'nowrap',
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: 'translateZ(0)',
    [theme.breakpoints.down('md')]: {
      marginRight: '0 !important',
    },

    '& li': {
      '& img': {
        backgroundSize: '80% auto',
      },
    },
  },
  btnRightAlignment: {
    display: 'flex',
    flexDirection: 'row-reverse',
  },
  overlayWrapper: {
    zIndex: '1400 !important',
    '& .MuiDialog-paper': {
      width: '100%',
      maxWidth: '100%',
      margin: 'auto',
      [theme.breakpoints.up('lg')]: {
        padding: '0 5%',
      },
      '& .slick-current': {
        zIndex: 10,
      },
      '& .slick-slider': {
        '& .slick-track': {
          alignItems: 'flex-start',
        },
      },

      '& .MuiDialogTitle-root, & .MuiDialogContent-root': {
        width: '100%',
        margin: 'auto',
        overflow: 'visible',
        [theme.breakpoints.up('lg')]: {
          width: '80%',
        },
      },

      '& .MuiDialogContent-root': {
        paddingTop: 0,
        '& .slider-wrapper': {
          [theme.breakpoints.down('md')]: {
            paddingTop: 0,
            ...theme.mixins.marginLR(-24, -24),
          },
        },
      },
      '& .MuiDialogTitle-root': {
        marginTop: theme.spacing(5),
        [theme.breakpoints.up('lg')]: {
          marginTop: 0,
        },
        '& h2': {
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          [theme.breakpoints.down('md')]: {
            flexDirection: 'column-reverse',
          },
          '& .slideCount': {
            marginBottom: pxToRem(8),
            color: theme.mixins.White(),
            [theme.breakpoints.up('lg')]: {
              alignSelf: 'center',
              marginTop: pxToRem(0),
              marginBottom: pxToRem(0),
              ...theme.mixins.marginRight(pxToRem(24)),
            },
          },
        },
      },
    },
    '&.tintOverlay': {
      '& .slick-slider .slick-next, & .slick-slider .slick-prev': {
        top: pxToRem(180),
        [theme.breakpoints.up('lg')]: {
          top: pxToRem(200),
        },
      },
    },
  },
  seeAllBtn: {
    position: 'absolute',
    bottom: pxToRem(38),
    ...theme.mixins.right(pxToRem(38)),
    background: theme.palette.common.white,
    width: pxToRem(106),
    height: pxToRem(40),
    borderRadius: borderRadius.b4,
    fontSize: fontSize.s14Rem,

    '& svg': {
      width: pxToRem(14),
      ...theme.mixins.marginRight(10),
    },

    '&:hover': {
      background: theme.palette.common.white,
    },

    '& .MuiButton-endIcon': {
      display: 'none',
    },

    '& .wrapInner': {
      display: 'flex',
      alignItems: 'center',
    },
  },
  overlayCardPicture: {
    '& .noRendition': {
      height: '100%',
    },
  },
  overlayCardDescription: {
    backgroundColor: theme.mixins.White(),
    color: theme.mixins.Black(),
    paddingTop: pxToRem(32),
    ...theme.mixins.paddingLR(pxToRem(24), pxToRem(24)),
    paddingBottom: pxToRem(48),
    [theme.breakpoints.up('lg')]: {
      padding: pxToRem(40),
    },
    '& .redColorText': {
      color: theme.mixins.AbuDhabiOrange(),
      display: 'inline',
    },
    '& .icon': {
      width: theme.spacing(5),
      height: theme.spacing(5),
      backgroundColor: theme.mixins.Grey(100),
      color: theme.mixins.Black(),
      [theme.breakpoints.up('lg')]: {
        width: theme.spacing(7),
        height: theme.spacing(7),
      },
      '& .MuiSvgIcon-root': {
        width: theme.spacing(3),
        height: theme.spacing(3),
        [theme.breakpoints.up('lg')]: {
          width: theme.spacing(4),
          height: theme.spacing(4),
        },
      },
    },
    '& .description': {
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(10),
    },
    '& .time-and-share': {
      alignItems: 'flex-end',
      justifyContent: 'flex-end',
      ...theme.mixins.marginRight(theme.spacing(2)),
    },
  },
  socialShareWrap: {
    textAlign: theme.mixins.textRight(),
  },
  shareMenuList: {
    margin: '0',
    padding: '0',
    listStyle: 'none',
  },
  shareMenuListItem: {
    margin: `${pxToRem(4)} 0`,
    padding: `${pxToRem(4)} ${pxToRem(8)}`,
  },
  shareMenuItemLink: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    minWidth: pxToRem(80),
    color: theme.palette.text.tertiary,
    textDecoration: 'none',
    '& .MuiTypography-root': {
      ...theme.mixins.marginLeft(pxToRem(8)),
    },
    '& svg': {
      width: pxToRem(15),
      height: pxToRem(15),
    },
  },
  shareIcon: {
    cursor: 'pointer',
    '& svg': {
      width: pxToRem(25),
      height: pxToRem(25),
    },
  },
  title: {
    marginBottom: pxToRem(24),
    [theme.breakpoints.up('lg')]: {
      marginBottom: pxToRem(32),
    },
  },
  titleWrap: {
    display: 'block',
    ...theme.mixins.marginLeft(theme.spacing(2)),
    '& p': {
      wordBreak: 'break-all',
    },
    '& .text-gray': {
      color: theme.palette.text.tertiary,
    },
  },
  overlayComponentWrapper: {
    '& .slick-slider .slick-next, & .slick-slider .slick-prev': {
      top: '20%',
      bottom: 'auto',
      [theme.breakpoints.up('lg')]: {
        top: '30%',
      },
    },
    [theme.breakpoints.down('md')]: {
      '& .slick-arrow': {
        '& .MuiSvgIcon-root': {
          width: pxToRem(16),
          height: pxToRem(16),
          top: '0',
          left: '0',
        },
      },
    },
    '& .slick-arrow > button': {
      borderWidth: '2px',
    },
    '& picture': {
      display: 'contents',
      '& img': {
        display: 'block',
      },
    },
  },
  firstRowAdjustment: {
    maxHeight: '50%',
    overflowY: 'hidden',
  },
  ugcWrapper: {
    position: 'relative',
    height: '100%',
    '& .MuiAvatar-root': {
      top: pxToRem(6),
      ...theme.mixins.right(pxToRem(3)),
    },
    [theme.breakpoints.up('lg')]: {
      '& .MuiAvatar-root': {
        top: pxToRem(16),
        ...theme.mixins.right(pxToRem(14)),
      },
    },
  },
  ugcLogo: {
    '&.MuiAvatar-root': {
      position: 'absolute',
      top: pxToRem(1),
      ...theme.mixins.right(pxToRem(2)),
      background: 'transparent',
      color: theme.mixins.White(),
      '& svg': {
        width: pxToRem(25),
        height: pxToRem(25),
      },
      [theme.breakpoints.up('lg')]: {
        top: pxToRem(4),
        ...theme.mixins.right(pxToRem(6)),
        '& svg': {
          width: pxToRem(30),
          height: pxToRem(30),
        },
      },
    },
  },
  secondRowTopMargin: {
    marginTop: `${pxToRem(24)} !important`,
  },
  topMargin: {
    marginTop: pxToRem(16),
  },
  overlayCard: {
    overflow: 'hidden',
    minWidth: pxToRem(320),
    minHeight: '100vh',
    [theme.breakpoints.up('lg')]: {
      minWidth: pxToRem(1045),
      minHeight: '80vh',
    },
  },
}));

export default useStyles;
